import {createContext} from "react";
import * as Utils from "../composants/utils/utils";

export const LanguageContext = createContext({
    langue: Utils.TRADUCTION.fr |Utils.TRADUCTION.en,
    setLangue: ()=>{}
});